import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", testId, ...props }) => {
    const [visible, setVisible] = useState(false);
    return (
        <div className="relative">
            <input
                {...props}
                data-testid={testId}
                type={visible ? "text" : "password"}
                className={`${className} pr-11`}
            />
            <button
                type="button"
                tabIndex={-1}
                data-testid={testId ? `${testId}-toggle` : "password-toggle"}
                aria-label={visible ? "Hide password" : "Show password"}
                onClick={() => setVisible(v => !v)}
                className="absolute right-0 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center text-burgundy/60 hover:text-burgundy transition-colors"
            >
                {visible ? <EyeOff size={17} /> : <Eye size={17} />}
            </button>
        </div>
    );
};

export default PasswordInput;
